import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import LandingPage from './components/LandingPage';
import FreeTrialApp from './components/FreeTrialApp';
import Pricing from './components/Pricing';
import PaymentSuccess from './components/PaymentSuccess';
import PaymentError from './components/PaymentError';

const AppRouter = () => {
  const { isAuthenticated, isLoading } = useAuth0();

  // Loading state
  if (isLoading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-indigo-50 to-purple-50 flex items-center justify-center">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-indigo-600 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-gray-600 font-medium">Loading StartPatriot...</p>
        </div>
      </div>
    );
  }

  return (
    <Routes>
      {/* Public landing page */}
      <Route path="/" element={<LandingPage />} />

      {/* Public pricing page */}
      <Route path="/pricing" element={<Pricing />} />

      {/* Payment success page */}
      <Route path="/payment/success" element={<PaymentSuccess />} />

      {/* Payment error page */}
      <Route path="/payment/error" element={<PaymentError />} />

      {/* Protected main app - Free Trial */}
      <Route
        path="/app"
        element={
          isAuthenticated ? <FreeTrialApp /> : <Navigate to="/" replace />
        }
      />

      {/* Catch all - redirect to home */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default AppRouter;
